import * as classnames from 'classnames/bind'
import ButtonForCopy from 'components/button_for_copy'
import * as React from 'react'
import { Component } from 'react'
import styles from './textarea_for_copy.module.scss'

const cx = classnames.bind(styles)

type Props = {
  buttonClassName?: string
  className?: string
  textareaClassName?: string
  value: string | null
  onUpdate: (value: string) => void
}

type State = {
  isFocus: boolean
  value: string
}

export default class TextareaForCopy extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isFocus: false,
      value: props.value
    }
  }

  private textarea?: HTMLTextAreaElement | null

  static getDerivedStateFromProps(nextProps, prevState) {
    const { value } = prevState

    if (value !== nextProps.value) {
      return {
        ...prevState,
        value: nextProps.value
      }
    }

    return prevState
  }

  handleChange(e) {
    const { onUpdate } = this.props
    const { value } = e.target

    this.setState({
      value
    })
    onUpdate(value)
  }

  handleFocus() {
    this.setState({
      isFocus: true
    })
  }

  handleBlur() {
    this.setState({
      isFocus: false
    })
  }

  render() {
    const { buttonClassName, className, textareaClassName } = this.props
    const { isFocus, value } = this.state

    return (
      <div className={cx(className, styles.formGroup)}>
        <textarea
          ref={ref => {
            this.textarea = ref
          }}
          value={value}
          className={cx(textareaClassName, styles.formControl)}
          onChange={e => this.handleChange(e)}
          onFocus={() => this.handleFocus()}
          onBlur={() => this.handleBlur()}
        />
        <ButtonForCopy
          className={cx(buttonClassName, styles.button, { buttonFocused: isFocus })}
          title={I18n.t('components.textarea_for_copy.button.copy')}
          fallbackTitle={I18n.t('components.textarea_for_copy.button.select')}
          target={() => this.textarea}
          toolTipPlacement="top"
        />
      </div>
    )
  }
}
